import requester from '@/lib/axios';
import { Assessment } from '@/models/Assessment';

const buildBaseUrl = (evaluationId: number) =>
  `evaluations/${evaluationId}/assessments`;

export const createAssessment = async (
  evaluationId: number,
  body: Partial<Assessment>,
) => {
  const { data } = await requester().post<Assessment>(
    `${buildBaseUrl(evaluationId)}/`,
    body,
  );
  return data;
};

export const updateAssessment = async (
  evaluationId: number,
  assessmentId: number,
  body: Partial<Assessment>,
) => {
  const { data } = await requester().patch<Assessment>(
    `${buildBaseUrl(evaluationId)}/${assessmentId}/`,
    body,
  );
  return data;
};

export const deleteAssessment = async (
  evaluationId: number,
  assessmentId: number,
) => {
  await requester().delete<void>(
    `${buildBaseUrl(evaluationId)}/${assessmentId}/`,
  );
};

export const updateAssessmentOrder = async (
  evaluationId: number,
  body: Array<{ id: number }>,
) => {
  await requester().patch<void>(
    `${buildBaseUrl(evaluationId)}/order/`,
    body,
  );
};